// extracted by mini-css-extract-plugin
export default {"menuWrapper":"UserMenu_menuWrapper__+NlKx","menuButton":"UserMenu_menuButton__bwBIJ","icon":"UserMenu_icon__BGxWx"};